export const VIDEO_MAP = {
  stripe: {
    billing: "https://youtu.be/ain2GwotE4s",
    bin: "https://youtu.be/ain2GwotE4s?t=27"
  },
  shopify: {
    billing: "https://youtu.be/-2dQOrrL5lI",
    bin: "https://youtu.be/-2dQOrrL5lI?t=35"
  },
  braintree: {
    billing: "https://youtu.be/nI5Oq2gW3hE",
    bin: "https://youtu.be/nI5Oq2gW3hE?t=17"
  },
  chargebee: {
    billing: "https://youtu.be/BxlBzgFtOek",
    bin: "https://youtu.be/BxlBzgFtOek?t=37"
  },
  recurly: "https://youtu.be/kQrnt9wwqQ8",
  airwallex: {
    billing: "https://youtu.be/jdD3P_Zw9Hk",
    bin: "https://youtu.be/jdD3P_Zw9Hk?t=43"
  },
  "authorize.net": "https://youtu.be/Qh0i_zjyB5U",
  nmi: "https://youtu.be/_cGJJgaGyIg",
  next: "https://youtu.be/ocM543aIhbY",
  // manual_refunds: "https://youtu.be/HsLZ7WZFVj8", // check CHA-10260
  default: "https://youtu.be/K0M99mEfBdk"
}

export const VIDEO_TITLES = {
  stripe: "How to Find Your Billing Descriptor & ARN Codes In Stripe",
  shopify: "How to Find Your Billing Descriptor & ARN Codes In Shopify",
  braintree: "How To Find Your Billing Descriptor & ARN Codes In Braintree",
  chargebee: "How To Find Your Billing Descriptor & ARN Codes In Chargebee",
  recurly: "How To Connect Recurly To Chargeback",
  airwallex: "How To Find Your Billing Descriptor & ARN Codes In Airwallex",
  "authorize.net": "How To Connect Authorize.net To Chargeback",
  nmi: "How To Find Your Billing Descriptor & ARN Codes In NMI",
  next: "How To Connect 29NEXT To Chargeback",
  // manual_refunds: "How to Setup Manual Refunds in Chargeback.io", // check CHA-10260
  default: "How to Setup Manual Refunds in Chargeback.io"
}

export const getVideoUrl = (payment, subStep) => {
  const videoConfig = VIDEO_MAP[payment] || VIDEO_MAP.default

  if (typeof videoConfig === "string") {
    return videoConfig
  }

  return videoConfig[subStep] || videoConfig.billing
}
